import { Chip, Tooltip } from "@mui/material";

const STATUS_META = {
  sold:           { label: "Sold",              color: "success", variant: "outlined" },
  partial_refund: { label: "Partially refunded", color: "warning", variant: "outlined" },
  refunded:       { label: "Refunded",          color: "error",   variant: "outlined" },
};

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export default function SaleStatusChip({ status, refundAmount, soldPrice }) {
  const meta = STATUS_META[status] || STATUS_META.sold;
  const tip =
    status === "partial_refund" && refundAmount > 0 && soldPrice > 0
      ? `Refunded ${money(refundAmount)} of ${money(soldPrice)}`
      : status === "refunded" && refundAmount > 0
      ? `Refunded ${money(refundAmount)}`
      : null;
  const chip = <Chip size="small" label={meta.label} color={meta.color} variant={meta.variant} />;
  return tip ? <Tooltip title={tip} arrow>{chip}</Tooltip> : chip;
}
